import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m.75 23.249 22.5-22.5m0 22.5L.75.749"
    }, null, -1)
  ]));
}
const interfaceClose = { render };
export {
  interfaceClose as default,
  render
};
//# sourceMappingURL=interface-close.svg.js.map
